import React from "react";

export default class extends React.Component {

  render() {
    return (
      <section className="space section">
      <div className="container ending-container">
        <div className='row center-xs'>
          <h1 className='heading'>Заключение</h1>
        </div>
        <div className="row start-xs">
          <div className="col-xs-12">
            <h2 className='subheading'>Мы, люди, одержимы скоростью. Планируется так усовершенствовать гиперзвуковые самолеты, чтобы те развивали скорость в пять раз превышающую скорость звука, т.е. свыше 6100 км/ч.</h2>
            <h2 className='subheading'>У таких самолетов не будет экипажа, но не потому, что люди не могут передвигаться с такой высокой скоростью. На самом деле люди уже перемещались со скоростью, которая в несколько раз выше скорости звука.</h2>
            <h2 className='subheading'>Однако существует ли предел, преодолев который наши стремительно несущиеся тела уже не смогут выдерживать перегрузки?</h2>
            <h2 className='subheading'>Нынешний рекорд скорости поровну принадлежит трем астронавтам, которые участвовали в космической миссии "Аполлон 10", - Тому Стаффорду, Джону Янгу и Юджину Сернану.</h2>
            <h2 className='subheading'>В 1969 году, когда астронавты облетели вокруг Луны и возвращались обратно, капсула в которой они находились, развила скорость, которая на Земле равнялась бы 39,897 км/час.  </h2>
            <h2 className='subheading'>Cто лет назад мы вряд ли могли себе представить, что человек сможет перемещаться в космосе со скоростью почти в 40 тысяч километров в час!</h2>
            </div>
          </div>
        </div>
      </section>
  );
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/Ending.js